import { MVEnv } from './types';

const env: MVEnv = {
  "env": "TEST",
  "myViasatUrl": "https://my-viasat-test.icat.viasat.io",
  "debug": {
    "auth": true,
    "dev": false,
    "showAnalytics": false,
    "skipLogin": false
  },
  "microfrontends": {
    "tsUsage": {
      "url": "https://my-viasat.ts-usage.test.icat.viasat.io/Usage"
    },
    "manageBilling": {
      "url": "https://my-viasat.ts-usage.test.icat.viasat.io/ManageBilling"
    },
    "overview": {
      "url": "https://my-viasat.ts-usage.test.icat.viasat.io/Overview"
    },
    "auth": {
      "url": "https://my-viasat.ts-usage.test.icat.viasat.io/auth"
    },
    "profile": {
      "url": "https://my-viasat.ts-usage.test.icat.viasat.io/Profile"
    }
  },
  "backEndUrls": {
    "backEndUrl": "https://my-viasat-test.icat.viasat.io/api/graphql",
    "androidBackEndUrl": "https://my-viasat-test.icat.viasat.io/api/graphql"
  },
  "adobeTargetScript": "https://assets.adobedtm.com/138ddf5a8359/0af984a4bffc/launch-f6bfd82339d3-development.min.js"
};


export default env;
